import { Point } from 'pixi.js'
import Layer from './index'
import { dimensions } from '../../config/settings'
import { LAYER_TINTS } from '../../config/constants'
import { addSmoke } from '../extra/Smoke'
import type { IItemInfo, ILayer } from '../../data/types'
import Snow from '../extra/Snow'

type VehiclePoint = { id: string; x: number; y: number }

export function addExtraObjects(layer: Layer, layerData: ILayer, isLowEnd: boolean): void {
  // const { extra } = layerData ?? {}

  switch (layer.name) {
    case 'layer_3':
      layer.addExtra(new Snow(new Point(0, 0), dimensions.MIN_WIDTH, dimensions.MIN_HEIGHT, isLowEnd ? 0 : 1))
      break
  }
  //   case 'layer_2': {
  //     addSmoke(layer, extra?.pozice_kominy ?? [], LAYER_TINTS.DEFAULT)
  //     break
  //   }

  //   case 'layer_3':
  //     addSmoke(layer, extra?.pozice_kominy ?? [], LAYER_TINTS.WHITE_ONLY)
  //     break

  //   case 'layer_4':
  //     addSmoke(layer, extra?.pozice_kominy ?? [], LAYER_TINTS.DEFAULT)
  //     break

  //   case 'layer_5':
  //     layer.addExtra(new Snow(new Point(0, 0), dimensions.MIN_WIDTH, dimensions.MIN_HEIGHT, isLowEnd ? 0 : 1))
  //     break
  // }
}
